import React from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { prepareColumnsAndGroups } from '../../../shared/Helper';

const SummarizedInventoryTable = ({ rows, visibleCols,laydownList = [], loader, filter }) => {
 
  const getLaydownValue = (row, metric, laydownId) => {
    return row?.["laydowns"]?.[laydownId]?.[metric]
  };

  const getChildren = (value) => {
    if(filter.length) {
      const data = value.filter(item => !filter.includes(item.id));
      return data.map(item => item.name)
    } else {
      return value.map(item => item?.name)
    }
  }

  const colValue = [
  ...(visibleCols.includes('part_name') ? [{
    key: 'part_name',
    value: 'part_name',
    hidden: false
  }] : []),
  
  ...(visibleCols.includes('description') ? [{
    key: 'description', 
    value: 'part_description',
    hidden: false
  }] : []),

  ...(visibleCols.includes('currentQty') && laydownList.length > 0 ? [{
    key: 'currentQty',
    value: 'current',
    hidden: false,
    children: getChildren(laydownList),
     width: 140
  }] : []),

  ...(visibleCols.includes('damagedQty') && laydownList.length > 0 ? [{
    key: 'damagedQty',
    value: 'damaged', 
    hidden: false,
    children: getChildren(laydownList),
     width: 140
  }] : []),

  ...(visibleCols.includes('remediateQty') && laydownList.length > 0 ? [{
    key: 'remediateQty',
    value: 'remediated',
    hidden: false,
    children: getChildren(laydownList),
     width: 140
  }] : []),

  ...(visibleCols.includes('distributedQty') ? [{
    key: 'distributedQty',
    value: 'distributed_quantity', 
    hidden: false
  }] : []),

  ...(visibleCols.includes('installedQty') ? [{
    key: 'installedQty',
    value: 'installed_quantity',
    hidden: false
  }] : []),

  ...(visibleCols.includes('quantityToReceive') ? [{
    key: 'quantityToReceive',
    value: 'quantity_yet_to_receive',
    hidden: false,
  }] : [])
];

  
const dataGridRows = rows?.map((row, index) => ({
  id: row.id || index,
  ...row,
  part_name: row.part_name,
  description: row.description,
  distributed_quantity: row.distributed_qty || 0,
  installed_quantity: row.installed_qty || 0,
  quantity_yet_to_receive: (row.required_qty || 0) - (row.delivered_qty || 0),
  ...laydownList.reduce((acc, laydown) => {
    acc[`current.${laydown.name}`] = getLaydownValue(row, 'current_quantity', laydown.id);
    acc[`damaged.${laydown.name}`] = getLaydownValue(row, 'damaged_quantity', laydown.id);
    acc[`remediated.${laydown.name}`] = getLaydownValue(row, 'remediated_quantity', laydown.id);
    return acc;
  }, {})
})) || [];

  const { visibleColumns, columnGroupingModel } = prepareColumnsAndGroups(
    colValue,
    null, 
    [], 
    null, 
    null, 
    [], 
    [] 
  );

  const modifiedColumns = visibleColumns.map(col => {
  if (col.field === 'distributed_quantity') {
    return {
      ...col,
      headerName: 'Distributed\nQuantity',
      renderHeader: (params) => (
        <div style={{ 
          whiteSpace: 'pre-line', 
          textAlign: 'center', 
          lineHeight: '1.2',
          fontWeight: 600 
        }}>
          {params.colDef.headerName}
        </div>
      )
    };
  }
  if (col.field === 'installed_quantity') {
    return {
      ...col,
      headerName: 'Installed\nQuantity',
      renderHeader: (params) => (
        <div style={{ 
          whiteSpace: 'pre-line', 
          textAlign: 'center', 
          lineHeight: '1.2',
          fontWeight: 600 
        }}>
          {params.colDef.headerName}
        </div>
      )
    };
  }
  if (col.field === 'quantity_yet_to_receive') {
    return {
      ...col,
      headerName: 'Quantity Yet\nTo Receive',
      renderHeader: (params) => (
        <div style={{ 
          whiteSpace: 'pre-line', 
          textAlign: 'center', 
          lineHeight: '1.2',
          fontWeight: 600 
        }}>
          {params.colDef.headerName}
        </div>
      )
    };
  }
  return col;
});


  return (
    <Box>
      <div style={{ height: "calc(100vh - 200px)", width: '100%', backgroundColor: '#ffffff' }}>
        <DataGrid
          rows={dataGridRows}
          columns={modifiedColumns}
          experimentalFeatures={{ columnGrouping: true }}
          columnGroupingModel={columnGroupingModel}
          disableColumnMenu
          disableSelectionOnClick
          disableRowSelectionOnClick
          loading={loader}
          hideFooter={true}
          pagination={false}
          // slots={{ pagination: CustomPagination }}
          sx={{
            '& .MuiDataGrid-columnSeparator': {
            //   display:"none"
            },
            '& .MuiDataGrid-main': {
              '& .MuiDataGrid-columnHeaders': {
                minHeight: '72px !important',
                '& .MuiDataGrid-columnHeader': {
                  fontWeight: 600,
                  whiteSpace: 'pre-line !important',
                  lineHeight: '1.2 !important',
                  textAlign: 'center',
                //   borderRight: '1px solid #fff',
                  '& .MuiDataGrid-columnHeaderTitle': {
                    whiteSpace: 'pre-line !important',
                    lineHeight: '1.2 !important',
                    overflow: 'visible !important',
                    textOverflow: 'initial !important',
                    fontWeight: 600,
                    width: '100%',
                    textAlign: 'center',
                  }
                },
                '& .MuiDataGrid-columnGroupHeader': {
                  fontWeight: 700,
                  whiteSpace: 'pre-line !important',
                  lineHeight: '1.2 !important',
                  textAlign: 'center',
                  borderRight: '1px solid #fff',
                  '& .MuiDataGrid-columnHeaderTitle': {
                    whiteSpace: 'pre-line !important',
                    lineHeight: '1.2 !important',
                    overflow: 'visible !important',
                    textOverflow: 'initial !important',
                    fontWeight: 700,
                    width: '100%',
                    textAlign: 'center',
                  }
                }
              }
            },
            '& .MuiDataGrid-cell': {
              borderRight: 'none',
            }  
          }}
        />
      </div>
    </Box>
  );
};

export default SummarizedInventoryTable;